module.exports = __webpack_public_path__ + "img/cy.0f4bc827.jpg";